<template>
  <div class="info-box overflow-hidden flex-1">
    <div class="flex-1 flex flex-col overflow-hidden">
      <ul class="flex items-center w-full">
        <el-button type="primary" icon="plus" link @click="onAdd">
          新增
        </el-button>
        <el-button
          type="warning"
          icon="plus"
          link
          @click="state.showGysk = true"
          v-if="props?.supplier_id"
        >
          选择常用项
        </el-button>
        <el-button
          type="success"
          icon="plus"
          link
          @click="state.showCbk = true"
        >
          成本库选择
        </el-button>
        <el-button type="danger" icon="Delete" link @click="onDeleteInvalid">
          清空无效行
        </el-button>
        <li class="flex-1 flex justify-end">
          <c_cell title="合计金额">
            <template #default>
              <c_money :key="state.total" :value="state.total" />
            </template>
          </c_cell>
        </li>
      </ul>
      <el-table
        ref="tabDom"
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        class="flex-1 mt-1"
        :show-overflow-tooltip="false"
      >
        <el-table-column label="类型" :width="140">
          <template #default="{ row }">
            <el-select
              v-model="row.d_cost_type"
              placeholder=""
              value-key="id"
              :title="row.d_cost_type_name"
              @change="
                (item) => {
                  row.d_cost_type_id = item.id;
                  row.d_cost_type_name = item.name;
                }
              "
            >
              <el-option
                v-for="item in state.lx_data"
                :key="item"
                :label="item.name"
                :value="item"
              />
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadLx()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="所属分会">
          <template #default="{ row }">
            <el-select
              v-model="row.meeting_place"
              placeholder=""
              value-key="id"
              :title="row.meeting_place_name"
              @change="
                (item) => {
                  row.meeting_place_id = item.id;
                  row.meeting_place_name = item.name;
                }
              "
            >
              <el-option
                v-for="item in state.fh_data"
                :key="item"
                :label="item.name"
                :value="item"
              />
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadFh()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="名称">
          <template #default="{ row }">
            <el-input v-model="row.name" :title="row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="规格" :width="140">
          <template #default="{ row }">
            <el-input
              v-model="row.specification"
              :title="row.specification"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单位" :width="90">
          <template #default="{ row }">
            <el-select
              v-model="row.d_measure_unit"
              placeholder=""
              value-key="id"
              :clearable="false"
              @change="
                (item) => {
                  row.d_measure_unit_id = item.id;
                  row.d_measure_unit_name = item.name;
                }
              "
            >
              <el-option
                v-for="item in state.dw_data"
                :key="item"
                :label="item.name"
                :value="item"
              />
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadDw()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="采购单价" :width="120" align="center">
          <template #default="{ row }">
            <el-input-number
              v-model="row.price"
              :min="0"
              precision="2"
              suffix="元"
              class="!w-full"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="采购数量" :width="100" align="center">
          <template #default="{ row }">
            <el-input-number
              v-model="row.count"
              :min="0"
              class="!w-full"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="天数" :width="100" align="center">
          <template #default="{ row }">
            <el-input-number
              v-model="row.day_count"
              :min="0"
              class="!w-full"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
            />
            <!-- <el-input-number
              v-model="row.day_count"
              :min="0"
              controls
              controls-position="right"
              class="!w-full tab-input-number"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
            /> -->
          </template>
        </el-table-column>
        <el-table-column label="备注" :width="300">
          <template #default="{ row }">
            <el-input v-model="row.remark"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="合计"
          prop="total"
          :formatter="$tab_PriceFormat"
          :width="120"
        />
        <el-table-column label="操作" :width="80" align="center">
          <template #default="{ row, column, $index }">
            <el-button
              type="danger"
              link
              size="large"
              @click="onDelete(row, $index)"
            >
              <template #icon>
                <el-icon :size="16"><Delete /></el-icon>
              </template>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        暂存
      </el-button>
    </div>
    <el-dialog
      v-model="state.showGysk"
      title="选择常用项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showGysk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_gysk
        :meeting_id="props.meeting_id"
        :data="state.list_data"
        :d_cost_type_pid="props.d_cost_type_pid"
        :supplier_id="props.supplier_id"
        @confirm="onGyskConfirm"
      />
    </el-dialog>
    <el-dialog
      v-model="state.showCbk"
      title="成本库选择"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showCbk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_cbk
        :meeting_id="props.meeting_id"
        :data="state.list_data"
        :d_cost_type_pid="props.d_cost_type_pid"
        @confirm="onCbkConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_getMeetingPlace,
  dic_getCostType,
  dic_getMeasureUnit,
} from "@/http/data";
import { toDecimal } from "@/utils/funcs";
import { ElMessage } from "element-plus";

import c_gysk from "./GongYingShangKu.vue";
import c_cbk from "./ChengBenKu.vue";

export default {
  components: {
    c_gysk,
    c_cbk,
  },
  props: {
    meeting_id: Number,
    list_data: Array,
    d_cost_type_pid: Number, //成本类型Id   父类型id
    supplier_id: Number,
    total: Number,
  },
  setup(props, { emit }) {
    let del_ids = []; //删除的明细项id集合，主要用于编辑提交时
    const tabDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      list_data: [],
    });
    onMounted(() => {
      if (props?.list_data?.length > 0) {
        state.list_data = JSON.parse(JSON.stringify(props.list_data));
        state.total = props.total;
      } else {
        state.list_data = [];
      }
      onLoadFh();
      onLoadLx();
      onLoadDw();
    });

    //新增一行
    const onAdd = () => {
      state.list_data.push({
        handle: "add",
        d_cost_type_pid: props.d_cost_type_pid,
        type: 0, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
      });

      setTimeout(() => {
        tabDom.value.setScrollTop(1000000);
      }, 200);
    };

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    //根据采购单的类型获取物料类型
    const onLoadLx = () => {
      if (props.d_cost_type_pid) {
        dic_getCostType({ pid: props.d_cost_type_pid }).then((res) => {
          if (res.status == 200) state.lx_data = res.data?.data || [];
        });
      }
    };

    //获取单位
    const onLoadDw = () => {
      dic_getMeasureUnit().then((res) => {
        if (res.status == 200) state.dw_data = res.data?.data || [];
      });
    };

    //采购单价、数量、天数改变时，计算行内合计，合计=采购单价*数量*天数
    const onBuildRowTotal = (row) => {
      if (typeof row.price == "number" && typeof row.count == "number") {
        row.total = toDecimal(row.price.toString() || "")
          .times(toDecimal(row.count.toString() || ""))
          .times(toDecimal((row.day_count || "1").toString()));

        onBuildTotal();
      }
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.list_data.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.total?.toString() || ""));
      }, toDecimal("0"));
      state.total = total;
    };

    //成本库选择完成事件
    const onCbkConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_data.push({
              handle: "add",
              type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place: { id: place.id },
              meeting_place_id: place.id,
              meeting_place_name: place.name,
              cost_item_id: e.id,
              d_cost_type_pid: props.d_cost_type_pid,
              d_cost_type: { id: e.d_cost_type_id },
              d_cost_type_id: e.d_cost_type_id,
              d_cost_type_name: e.d_cost_type_name,
              name: e.name,
              d_measure_unit: { id: e.d_measure_unit_id },
              d_measure_unit_id: e.d_measure_unit_id,
              d_measure_unit_name: e.d_measure_unit_name,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_data.push({
            handle: "add",
            type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.id,
            d_cost_type_pid: props.d_cost_type_pid,
            d_cost_type: { id: e.d_cost_type_id },
            d_cost_type_id: e.d_cost_type_id,
            d_cost_type_name: e.d_cost_type_name,
            name: e.name,
            d_measure_unit: { id: e.d_measure_unit_id },
            d_measure_unit_id: e.d_measure_unit_id,
            d_measure_unit_name: e.d_measure_unit_name,
            specification: e.specification,
            price: e.price,
          });
        });
      }

      // state.list_data = [...state.list_data, data];
      delete state.showCbk;
    };

    //供应商常用项选择完成事件
    const onGyskConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_data.push({
              handle: "add",
              type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place: { id: place.id },
              meeting_place_id: place.id,
              meeting_place_name: place.name,
              cost_item_id: e.cost_item_id,
              supplier_cost_item_id: e.id,
              d_cost_type_pid: props.d_cost_type_pid,
              d_cost_type: { id: e.d_cost_type_id },
              d_cost_type_id: e.d_cost_type_id,
              d_cost_type_name: e.d_cost_type_name,
              name: e.name,
              d_measure_unit: { id: e.d_measure_unit_id },
              d_measure_unit_id: e.d_measure_unit_id,
              d_measure_unit_name: e.d_measure_unit_name,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_data.push({
            handle: "add",
            type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.cost_item_id,
            supplier_cost_item_id: e.id,
            d_cost_type_pid: props.d_cost_type_pid,
            d_cost_type: { id: e.d_cost_type_id },
            d_cost_type_id: e.d_cost_type_id,
            d_cost_type_name: e.d_cost_type_name,
            name: e.name,
            d_measure_unit: { id: e.d_measure_unit_id },
            d_measure_unit_id: e.d_measure_unit_id,
            d_measure_unit_name: e.d_measure_unit_name,
            specification: e.specification,
            price: e.price,
          });
        });
      }

      // state.list_data = [...state.list_data, data];
      delete state.showGysk;
    };

    //清空无效行
    const onDeleteInvalid = () => {
      state.list_data = state.list_data.filter(
        (e) =>
          ((e.type === 1 && e.cost_item_id) ||
            (e.type === 2 && e.supplier_cost_item_id && e.cost_item_id) ||
            e.type === 0) &&
          e.meeting_place_id &&
          e.d_cost_type_id &&
          e.name &&
          e.d_measure_unit_id &&
          typeof e.price == "number" &&
          typeof e.count == "number",
      );
    };

    //删除行
    const onDelete = (row, index) => {
      if (row.handle == "edit") del_ids.push(row.id);
      state.list_data.splice(index, 1);
      onBuildTotal();
    };

    const onSubmit = () => {
      if (!state.list_data || state.list_data.length <= 0) {
        ElMessage.warning("请添加采购记录");
        return false;
      }

      let invalidIndexs = [];
      state.list_data.forEach((e, i) => {
        if (
          !(
            ((e.type === 1 && e.cost_item_id) ||
              (e.type === 2 && e.supplier_cost_item_id && e.cost_item_id) ||
              e.type === 0) &&
            e.meeting_place_id &&
            e.d_cost_type_id &&
            e.name &&
            e.d_measure_unit_id &&
            typeof e.price == "number" &&
            e.count
          )
        ) {
          invalidIndexs.push(i + 1);
        }
      });

      if (invalidIndexs?.length > 0) {
        ElMessage.warning(
          `列表第${invalidIndexs.join(",")}行数据不完整，请修改`,
        );
        return false;
      }

      emit("confirm", { rows: state.list_data, total: state.total, del_ids });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onAdd,
      tabDom,
      onLoadLx,
      onLoadFh,
      onLoadDw,
      onCbkConfirm,
      onGyskConfirm,
      onDeleteInvalid,
      onBuildRowTotal,
      onBuildTotal,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
